import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";
import { FormLabel, FormGroup } from "@material-ui/core";
import CheckBox from "../Forms/CheckboxWithLabel";
import { getListValues } from "../../API/List";
import { useTranslation } from "react-i18next";
import { styles } from "./styles";

const RecordTypeFilter = (props) => {
  const { classes, onSearchCriteriaChange } = props;
  const { t } = useTranslation();
  const [entityCategories, setEntityCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState({});

  useEffect(() => {
    const getEntityCategories = async () => {
      try {
        const results = await getListValues({ listName: "Legal Status" });
        const { data = [] } = results;
        setEntityCategories(data);
        setSelectedCategories(data.reduce(function (sc, c) {
          sc[c.code] = true;
          return sc;
        }, {}))
      } catch (error) {
        console.log(error);
      }
    };
    getEntityCategories();
  }, []);

  const handleChange = async (e, cetegory) => {
    setSelectedCategories({ ...selectedCategories, [cetegory]: e.target.checked });
    const ecs = [];
    for (let c of entityCategories) {
      if (c.code === cetegory) {
        if (e.target.checked) {
          ecs.push(c.code);
        }
      } else if (selectedCategories[c.code]) {
        ecs.push(c.code);
      }
    }
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ entityCategories: ecs });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t('labels.filter.byRecordType')}</FormLabel>
      {
        <FormGroup>
          {entityCategories.map((c, index) => {
            return (
              <div className={classes.checkBoxContainer} key={index}>
                <CheckBox
                  label={t(`labels.filter.${c.value}`)}
                  onChange={(e) => handleChange(e, c.code)}
                  value={selectedCategories[c.code] || false}
                />
              </div>
            );
          })}
        </FormGroup>
      }
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(RecordTypeFilter);
